import { Box, Paper, TextField, Typography } from '@material-ui/core'

import * as R from 'ramda'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import FormSingleFileDropZone from '../../components/form/SingleFileDropZone'
import FormSingleSelector from '../../components/form/SingleSelector'
import { URL_REGEX_PATTERN } from '../../constants/regexes/common.regex.constant'
import {
  CATEGORY_TYPE,
  CategoryDetailInterface
} from '../../interfaces/category'

const StyledPaperContainer = styled(Paper)`
  padding: 10px;
  margin: 20px 10px;
`

const StyledLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
`

const StyledLabelContainer = styled.div`
  width: 100%;
  margin-bottom: 15px;
`

const StyledFormGroupContainer = styled.div`
  margin: 20px 20% 20px 20%;
`

const StyledFormFieldContainer = styled.div`
  margin: 15px 0px 15px 0px;
  padding: 0px;
`

const StyledErrorMessageContainer = styled.div`
  height: 20px;
  width: 100%;
  display: flex;
  align-items: center;
`

const StyledFormSubTitle = styled.div`
  margin-left: 15px;
`

// TODO: refactor to perform scroll inside the form
const StyledFormContainer = styled.div`
  padding: 0px 10px;
  overflow-y: auto;
  max-height: 70vh;
`

const FormLabel = ({ name }: { name: string }) => (
  <StyledLabelContainer>
    <StyledLabel>{name}</StyledLabel>
  </StyledLabelContainer>
)

const FormErrorMessage = ({ message }: { message: string }) => (
  <Box component="div" display="line" fontSize={10} color="red">
    {message}
  </Box>
)

const CategoryFormMainBody = ({
  categoryDetail
}: {
  categoryDetail: CategoryDetailInterface
}) => {
  const { errors, control } = useFormContext()
  const textFieldInputProps = { style: { fontSize: 13 } }

  return (
    <StyledFormContainer>
      <StyledPaperContainer elevation={3}>
        <StyledFormSubTitle>
          <Typography variant="subtitle1">Basic Information</Typography>
        </StyledFormSubTitle>
        <StyledFormGroupContainer>
          <StyledFormFieldContainer>
            <FormLabel name="Category Name" />
            <Controller
              name="name"
              control={control}
              defaultValue={R.pathOr('', ['name'], categoryDetail)}
              rules={{
                required: {
                  value: true,
                  message: '* Your input is required'
                }
              }}
              render={({ onChange }) => (
                <TextField
                  onChange={onChange}
                  required
                  id="outlined-required"
                  label="Required"
                  variant="outlined"
                  defaultValue={R.pathOr('', ['name'], categoryDetail)}
                  inputProps={textFieldInputProps}
                  fullWidth
                />
              )}
            />
            <StyledErrorMessageContainer>
              {errors.name && (
                <FormErrorMessage message={errors?.name?.message as string} />
              )}
            </StyledErrorMessageContainer>
          </StyledFormFieldContainer>
          <StyledFormFieldContainer>
            <FormLabel name="Category Type" />
            <FormSingleSelector
              fieldName="type"
              selections={Object.values(CATEGORY_TYPE)}
              defaultValue={CATEGORY_TYPE.Other}
              required
            />
          </StyledFormFieldContainer>
          <StyledFormFieldContainer>
            <FormLabel name="Remark" />
            <Controller
              name="remark"
              control={control}
              defaultValue={R.propOr('', 'remark', categoryDetail)}
              render={({ onChange }) => (
                <TextField
                  onChange={onChange}
                  required
                  id="outlined"
                  variant="outlined"
                  defaultValue={R.propOr('', 'remark', categoryDetail)}
                  inputProps={textFieldInputProps}
                  fullWidth
                />
              )}
            />
          </StyledFormFieldContainer>
          <StyledFormFieldContainer>
            <FormLabel name="Blog Url" />
            <Controller
              name="blogUrl"
              control={control}
              defaultValue={R.propOr('', 'blogUrl', categoryDetail)}
              rules={{
                pattern: {
                  value: URL_REGEX_PATTERN,
                  message: '* Invalid url'
                }
              }}
              render={({ onChange }) => (
                <TextField
                  onChange={onChange}
                  id="outlined"
                  variant="outlined"
                  defaultValue={R.propOr('', 'blogUrl', categoryDetail)}
                  inputProps={textFieldInputProps}
                  fullWidth
                />
              )}
            />
            <StyledErrorMessageContainer>
              {errors.blogUrl && (
                <FormErrorMessage
                  message={errors?.blogUrl?.message as string}
                />
              )}
            </StyledErrorMessageContainer>
          </StyledFormFieldContainer>
        </StyledFormGroupContainer>
      </StyledPaperContainer>
      <StyledPaperContainer>
        <StyledFormSubTitle>
          <Typography variant="subtitle1">Images</Typography>
        </StyledFormSubTitle>
        <StyledFormGroupContainer>
          <StyledFormFieldContainer>
            <FormLabel name="Category Image" />
            <FormSingleFileDropZone fieldName="imageFile" />
          </StyledFormFieldContainer>
        </StyledFormGroupContainer>
      </StyledPaperContainer>
    </StyledFormContainer>
  )
}

export default CategoryFormMainBody
